import { type IPikProjectsItemViewModel } from '../IPikProjectsItemViewModel';

/**
 * @description Модель представления элемента списка проектов
 */
export class PikProjectsItemViewModel implements IPikProjectsItemViewModel {
  public readonly chipsOption: IPikProjectsItemViewModel['chipsOption'];
  public readonly type: IPikProjectsItemViewModel['type'];

  public constructor(chipsOption: IPikProjectsItemViewModel['chipsOption'], type: IPikProjectsItemViewModel['type']) {
    this.chipsOption = chipsOption;
    this.type = type;
  }
}
